"use client"

import axios from "axios"
import { Formik, Form } from "formik"
import { useRouter } from "next/navigation"
import React from "react"
import * as Yup from "yup"

import Button from "../Button"

import PressFormTextArea from "./PressFormTextArea"
import PressTextInput from "./PressTextInput"
// import Head from 'next/head'

const PressForm: React.FC = () => {
  // const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITE_KEY // Updated to NEXT_PUBLIC
  const router = useRouter()
  const PressFormValidationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    businessEmailAddress: Yup.string()
      .email("Invalid email address")
      .required("Required"),
    organization: Yup.string().required("Required"),
    message: Yup.string().required("Required"),
  })

  return (
    <>
      {/* <Head> next-comment
        <script src="https://www.google.com/recaptcha/api.js" async defer />
      </Head> */}
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          businessEmailAddress: "",
          organization: "",
          message: "",
        }}
        validationSchema={PressFormValidationSchema}
        onSubmit={(values) => {
          axios
            .post(
              "https://www.workato.com/webhooks/rest/33695466-4300-4cf8-8538-c95e30096378/contact-press-form",
              {
                values,
              },
            )
            .then((res) => {
              if (res.status === 200) {
                router.push("/lp/thank-you-contact-press/")
              }
            })
        }}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <PressTextInput
              name="firstName"
              id="firstName"
              type="text"
              placeholder="First Name"
            />
            <PressTextInput
              name="lastName"
              id="lastName"
              type="text"
              placeholder="Last Name"
            />
            <PressTextInput
              name="businessEmailAddress"
              id="businessEmailAddress"
              type="text"
              placeholder="Business Email Address"
            />
            <PressTextInput
              name="organization"
              id="organization"
              type="text"
              placeholder="Organization"
            />
            <PressFormTextArea name="message" placeholder="Message" />
            {/* <div
              className="mt-12 g-recaptcha"
              data-sitekey={recaptchaSiteKey}
            /> */}
            <Button
              onClick={(e) => {
                e.preventDefault() // Prevent the default form submission behavior
                formik.handleSubmit() // Call the formik submit handler
              }}
              size="lg"
              type="submit"
              className="mt-12"
            >
              Contact Press
            </Button>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default PressForm
